import React from 'react';
import { Alert, Typography } from 'antd';

import ActionIcon from '../../../components/ActionIcon.jsx';

const { Text } = Typography;

/**
 * The server's pricing guard (GET /pricing/guard, IP-62), over the dealing
 * dates of the orders waiting for review and approval - the same check
 * ORDER_APPROVE makes before it posts anything. While any ACTIVE fund that
 * needs a price for a date lacks a published (approved) one, an
 * approval request naming that date is refused whole (PRICING_GUARD), so the
 * page holds those orders back rather than send a request that cannot pass.
 * It replaces the prototype's browser-side "priced today", which knew
 * nothing of dealing dates.
 *
 * @param {{ blocked: Map<string, string[]>, error: string|null }} props blocked: date -> funds with no price
 */
const PricingGuard = ({ blocked, error }) => {
    if (error) {
        return (
            <Alert
                type="warning"
                showIcon
                style={{ marginBottom: 16 }}
                title="The pricing check could not be read"
                description={error + ' Approving may be refused until every fund is priced for its dealing date.'}
            />
        );
    }
    if (!blocked.size) return null;

    const dates = [...blocked.keys()];
    return (
        <div className="pricing-guard-info">
            <ActionIcon name="info" />
            <div>
                <div>
                    No published unit price for {dates.length} dealing date{dates.length === 1 ? '' : 's'} - approving those transactions is held
                </div>
                <div>
                    Transactions dealt on these dates cannot be approved until the fund&apos;s price is approved and published on
                    Fund Register. Reviewing, sending back and rejecting them are not affected.
                </div>
                <div className="pricing-guard-dates">
                    {dates.map((date) => (
                        <div key={date}>
                            <Text strong>{date}</Text>{' '}
                            <Text type="secondary">no price for {blocked.get(date).join(', ')}</Text>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default PricingGuard;
